// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1bSQK","name":"Header_name__2Ng7W","birthday":"Header_birthday__3dzGw","skeleton":"Header_skeleton__1PHTs"};